import { Segmented, SegmentedProps } from 'antd'
import styled from 'styled-components'

export interface Segment extends SegmentedProps {}
export const Segment = styled(Segmented)<Segment>`
	&.ant-segmented {
		padding: 2px;
		border-radius: 4px;
		width: 100%;
		background-color: ${(props) => props.theme.new.colors.sol_gray_50};
		.ant-segmented-group {
			.ant-segmented-item {
				border-radius: 4px;
				width: 100%;
				box-shadow: 3px 3px 12px 0px rgba(28, 31, 46, 0.06);
				.ant-segmented-item-label {
					font-size: 16px;
					font-weight: 600;
					color: ${(props) => props.theme.new.colors.sol_gray_500};
					padding: 10px 12px;
					line-height: 1.5;
				}
			}
			.ant-segmented-item-selected .ant-segmented-item-label {
				color: ${(props) => props.theme.new.colors.sol_gray_700};
			}
		}

		@media (max-width: 768px) {
			&.ant-segmented {
				.ant-segmented-group {
					.ant-segmented-item-label {
						font-size: 14px;
						line-height: 22px;
					}
				}
			}
		}
	}
`
